import { IconName } from '@optimus-web/icons';
import { EnterpriseLink } from '@mews-commander/ui';
import { Target } from '@mews/enums';
import { Divider, DropDownButton, DropdownItem } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { useDeleteServiceProductDialog } from '../../../hooks/useDeleteServiceProductDialog';

interface Props {
    productId: string;
    currentEnterpriseId: string;
}
export const RowActionCell = ({ productId, currentEnterpriseId }: Props) => {
    const { openConfirmationDialog, confirmationDialog } = useDeleteServiceProductDialog({
        productIds: [productId],
        currentEnterpriseId,
    });

    return (
        <>
            <DropDownButton icon={IconName.More} size="small" variant="ghost">
                <EnterpriseLink
                    underline={false}
                    target={Target.Blank}
                    standalone
                    variant="basic"
                    to="Product/Detail/$productId"
                    params={{
                        currentEnterpriseId,
                        productId,
                    }}
                >
                    <DropdownItem label={lt('ViewDetails')} />
                </EnterpriseLink>
                <Divider />
                <DropdownItem label={lt('DeleteProduct')} variant="danger" onClick={openConfirmationDialog} />
            </DropDownButton>
            {confirmationDialog}
        </>
    );
};
